import { useEffect, useState } from "react";

import Box from "@mui/material/Box";

import StatsBoxes from "./Boxes";
import StatsControls from "./Controls";
import StatsList from "./List";

import BackdropLoader from "../../../../components/BackdropLoader";
import GeneralStatsSkeleton from "../../../../components/skeletons/GeneralStatsSkeleton";
import { useGetCurrentCompanyBranchesQuery } from "../../../branches/branchesApiSlice";
import { useGetCurrentUserQuery } from "../../../user/userApiSlice";
import { useGetCompanyGeneralStatsQuery } from "../../statisticsApiSlice";

const today = new Date();

const GeneralStatistics = () => {
	const { data: user } = useGetCurrentUserQuery(undefined);
	const isBranchManager = user?.role === "branch-manager";

	const {
		data: branches,
		error: branchesError,
		isLoading: isLoadingBranches,
	} = useGetCurrentCompanyBranchesQuery();

	const [branchValue, setBranchValue] = useState(
		isBranchManager ? user?.company_branch_id : ""
	);
	const [rangeValue, setRangeValue] = useState([today, today]);
	const [weightValues, setWeightValues] = useState({ from: "", to: "" });
	const onWeightChange = (e, type) => {
		if (type === "from") {
			setWeightValues({ ...weightValues, from: e.target.value });
		} else {
			setWeightValues({ ...weightValues, to: e.target.value });
		}
	};

	const [filterValues, setFilterValues] = useState({
		branch: isBranchManager ? user?.company_branch_id : "",
		range: rangeValue.map((date) => {
			const formatter = new Intl.DateTimeFormat("en", {
				month: "2-digit",
				year: "numeric",
			});
			const [month, year] = formatter.format(date).split("/");
			return `${month}_${year}`;
		}),
		weightFrom: "",
		weightTo: "",
	});

	const {
		data: stats,
		error,
		isLoading,
		refetch,
	} = useGetCompanyGeneralStatsQuery(filterValues);

	const [isRefetching, setIsRefetching] = useState(false);

	const handleSubmit = async () => {
		setIsRefetching(true);
		const parsedRange = rangeValue.map((date) => {
			const formatter = new Intl.DateTimeFormat("en", {
				month: "2-digit",
				year: "numeric",
			});
			const [month, year] = formatter.format(date).split("/");
			return `${month}_${year}`;
		});

		if (
			filterValues.branch === branchValue &&
			filterValues.range === encodeURIComponent(parsedRange) &&
			filterValues.weightFrom === weightValues.from &&
			filterValues.weightTo === weightValues.to
		) {
			await refetch();
			return;
		}

		setFilterValues({
			branch: branchValue,
			range: encodeURIComponent(parsedRange),
			weightFrom: weightValues.from,
			weightTo: weightValues.to,
		});
	};

	useEffect(() => {
		setIsRefetching(false);
	}, [stats, error]);

	if (isLoading || isLoadingBranches) {
		return <GeneralStatsSkeleton />;
	}

	return (
		<>
			<Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
				<StatsControls
					disableBranchSelect={isBranchManager}
					onBranchChange={isBranchManager ? () => {} : setBranchValue}
					branchValue={branchValue}
					branchOptions={branches.map((branch) => {
						return { value: branch.id, label: branch.name };
					})}
					onRangeChange={setRangeValue}
					rangeValue={rangeValue}
					weightFrom={weightValues.from}
					onWeightFromChange={(e) => onWeightChange(e, "from")}
					weightTo={weightValues.to}
					onWeightToChange={(e) => onWeightChange(e, "to")}
					onSubmit={handleSubmit}
					isLoading={isRefetching}
				/>
				<StatsBoxes data={stats.summary} />
				<StatsList data={stats.perUser} />
			</Box>
			<BackdropLoader isOpen={isRefetching} />
		</>
	);
};

export default GeneralStatistics;
